import Cookies from "js-cookie";
import {useLocation, useNavigate} from "react-router-dom";
import React, {Fragment, useEffect, useState} from "react";
import {routes, useGetDataCreateAsset} from "../routes/api";
import Grid from "@mui/material/Grid";
import {Autocomplete, Divider, Typography} from "@mui/material";
import TextField from "@mui/material/TextField";
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import AddIcon from '@mui/icons-material/Add';
import PopupDialog from "./popupDialog";
import {relationContent} from "../util/util";
import Box from "@mui/material/Box";


export default function RelationView({alias, fields, handleChange, relationName, currentValue, handleNew}) {
    const token = Cookies.get('token');
    const permissions = Cookies.get('permissions') ?
        JSON.parse(Cookies.get('permissions'))[alias === 'camera' ? 'unit' : alias] :
        {create: false, edit: false, delete: false, view: false};
    const webAdmin = Cookies.get('webAdmin') === 'T';
    const route = routes[alias];
    const adminRelation = Object.values(fields).reduce((acc, item, _) => ({
        ...acc,
        [item.alias]: item.admin
    }), {});
    const {data: content, loading, handleCall} = useGetDataCreateAsset(token, route);
    const [openStates, setOpenStates] = useState({});
    const [openDialogs, setOpenDialogs] = useState({});
    const [relations, setRelations] = useState({});
    const [hasOrg, setHasOrg] = useState(false);

    const navigate = useNavigate();
    const location = useLocation();

    const from = location.state?.from ? location.state.from : {pathname: `/`};

    const fetchData = async () => {
        try {
            // setLoading(true);
            await handleCall();
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (!loading) {
            setOpenStates(Object.entries(content).reduce((acc, item, index) => ({...acc, [index]: false}), {}));
            setOpenDialogs(Object.entries(content).reduce((acc, item, index) => ({...acc, [index]: false}), {}));
            if (relationName) {
                setRelations(relationName.reduce((result, key) => {
                    if (content[key]) {
                        result[key] = content[key];
                    }
                    return result;
                }, {}));
                setHasOrg(relationName.includes('organization') && Object.keys(content).includes('organization'));
            } else {
                setHasOrg(Object.keys(content).includes('organization'));
                setRelations(content);
            }
            // setLoading(false);
        }
    }, [content]);

    const handleOpen = (key) => {
        setOpenStates((prevOpenStates) => ({...prevOpenStates, [key]: true}));
    };

    const handleClose = (key) => {
        setOpenStates((prevOpenStates) => ({...prevOpenStates, [key]: false}));
    };

    const handleRelationRefresh = async (key) => {
        setOpenDialogs({...openDialogs, [key]: false});
        await handleCall();
    }

    const handleAddButton = (key) => {
        setOpenDialogs({...openDialogs, [key]: true})
    }

    const handleDialogClose = (key) => {
        setOpenDialogs({...openDialogs, [key]: false});
    }

    const getValue = (options, key, multiple) => {
        let value;
        if (!currentValue[key]) {
            value = multiple ? [] : null;
        } else if (multiple) {
            value = currentValue[key].map(item => options.find(option => option[0] === item)).filter(item => item);
        } else {
            value = options.find(option => option[0] === currentValue[key]) || null;
        }
        return value;
    }

    if (loading) return <Box
        sx={{
            display: 'flex',
            justifyContent: "space-around",
            alignItems: 'center',
            mb: 5
        }}>
        <CircularProgress color="inherit"/>
    </Box>;

    return (
        <Grid container
              spacing={2}
              alignItems="center"
              sx={{mb: 5}}
        >
            {hasOrg &&
                <Grid
                    size={{xs: 12, md: 6, xl: 3}}
                    key={'organization-select'}
                    sx={{display: 'flex', justifyContent: 'flex-start', alignItems: 'stretch'}}>
                    <Autocomplete
                        id='organization'
                        open={openStates['organization'] || false}
                        onOpen={() => {
                            handleOpen('organization')
                        }}
                        onClose={() => {
                            handleClose('organization')
                        }}
                        label='organization'
                        name='organization'
                        value={getValue(relations.organization.data, 'for_organization', relations.organization.multiple)}
                        isOptionEqualToValue={(option, v) => v ? option[0] === v[0] : false}
                        getOptionLabel={(option) => option[1]}
                        getOptionKey={(option) => option[0]}
                        options={relations.organization.data}
                        onChange={(e, newValue) => {
                            handleChange(newValue, 'for_organization', relations.organization.multiple, relations.organization.limit);
                        }}
                        loading={loading}
                        multiple={relations.organization.multiple}
                        disableCloseOnSelect={relations.organization.multiple}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label={relations.organization.label}
                                helperText={`The ${alias} will be added to user's organization if none was provided`}
                                slotProps={{
                                    input: {
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {loading ? <CircularProgress color="inherit" size={20}/> : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }
                                }}
                            />
                        )}
                        sx={{maxWidth: 350}}
                    />
                </Grid>}
            {!relationName && <>
                <Grid size={12} sx={{mt: 3}}>
                    <Typography variant='h5'>Additional Information</Typography>
                </Grid>
                <Grid size={12} sx={{mb: 2}}>
                    <Divider/>
                </Grid>
            </>
            }
            {Object.entries(relations).filter(([_, value]) => value).map(([key, value], index) => (
                key !== 'organization' && ((!adminRelation[key]) || webAdmin) && <Fragment key={`${key}-group`}>
                    <Grid size={6} key={`${key}-select`}>
                        <Autocomplete
                            id={key}
                            open={openStates[key] || false}
                            onOpen={() => {
                                handleOpen(key)
                            }}
                            onClose={() => {
                                handleClose(key)
                            }}
                            label={key}
                            name={key}
                            value={getValue(value.data, key, value.multiple)}
                            isOptionEqualToValue={(option, v) => v ? option[0] === v[0] : false}
                            getOptionLabel={(option) => option[1]}
                            getOptionKey={(option) => option[0]}
                            options={value.data}
                            onChange={(e, newValue) => {
                                handleChange(newValue, key, value.multiple, value.limit);
                            }}
                            loading={loading}
                            multiple={value.multiple}
                            disableCloseOnSelect={value.multiple}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label={value.label}
                                    helperText={value.limit && `${value.label} limited up to ${value.limit}`}
                                    slotProps={{
                                        input: {
                                            ...params.InputProps,
                                            endAdornment: (
                                                <>
                                                    {loading ? <CircularProgress color="inherit" size={20}/> : null}
                                                    {params.InputProps.endAdornment}
                                                </>
                                            ),
                                        }
                                    }}
                                />
                            )}
                        />
                    </Grid>
                    {(relationContent[value.type] && fields[value.type].addNew) &&
                        <>
                            <Grid size={4} key={`${key}-addNew`}>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    startIcon={<AddIcon/>}
                                    onClick={() => handleAddButton(index)}>
                                    New
                                </Button>
                            </Grid>
                            <Grid size={2} key={`${key}-popup`}>
                                <PopupDialog
                                    open={openDialogs[index]}
                                    display={value.type}
                                    content={relationContent[value.type]((v) => handleNew(v, key, value.multiple, value.limit), () => handleRelationRefresh(index))}
                                    handleClose={() => handleDialogClose(index)}
                                /></Grid>

                        </>}
                </Fragment>
            ))}
        </Grid>
    );
}